import URI from '@dw/urijs-esm';

/**
 * @param {Object} data - Router data context
 * When signup query param found in URL,
 *  - Stores `analytics-signup`: true into localStorage
 *  - Stores `analytics-invited` value from invited query param.
 * When `recaptcha-threshold` query param found in URL (full-page login/signup landing
 * after server-side reCAPTCHA validation),
 *  - Stores it into `analytics-recaptcha-threshold` localStorage so the `login` / `signup`
 *    analytics event can include it (read & cleared in `trackLoginEvent` /
 *    `trackSignupEvent`).
 *  - Removes the handled query params from URL & redirect to new URL.
 */
export const signupEventTrackingRouter = (data) => {
  return new Promise((resolve, reject) => {
    const queryParams = new URI(data.query).query(true);
    const recaptchaThreshold = queryParams['recaptcha-threshold'];
    if(queryParams.signup || recaptchaThreshold) {

      if(queryParams.signup) {
        const signup = queryParams.signup === 'true'? true: false;
        const invited = queryParams.invited === 'true'? true: false;

        localStorage && localStorage.setItem && localStorage.setItem('is-invited-user', invited);
        localStorage && localStorage.setItem && localStorage.setItem('analytics-signup', signup);
        localStorage && localStorage.setItem && localStorage.setItem('analytics-invited', invited);
      }

      if(recaptchaThreshold) {
        localStorage && localStorage.setItem && localStorage.setItem('analytics-recaptcha-threshold', recaptchaThreshold);
      }

      let uri = new URI();
      uri.pathname(data.path);
      uri.query(data.query);
      uri.removeSearch('signup');
      uri.removeSearch('invited');
      uri.removeSearch('recaptcha-threshold');
      uri.removeSearch('recaptcha-action');
      data.redirect = uri.toString().replace(`${uri.protocol()}:\/\/${uri.host()}`, '');
      resolve(data);
      return;
    }
    reject(data);
  });
}
